import { useMutation, useQueryClient } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import meKeys from '@/api/queries/me/keyFactory';
import { graphql } from '@/gql';

const GenerateCalendarFeedTokenMutation = graphql(`
  mutation GenerateCalendarFeedToken {
    generateCalendarFeedToken {
      url
      webcalUrl
    }
  }
`);

export const useGenerateCalendarFeedToken = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => gqlClient.request(GenerateCalendarFeedTokenMutation),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: meKeys.calendarFeed() });
    },
  });
};

export default useGenerateCalendarFeedToken;
